import { createContext } from "react";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import { DEFAULT_FUNCTION, DEFAULT_QUERY } from "../../utils/helpers/constants";
import { IHomePageSectionsArrangementList } from "../../models/arrange_sections_page_home/response";
import { IHomePageSectionsArrangementQuery } from "../../models/arrange_sections_page_home/query";
import { IHomePageSectionsArrangement } from "../../models/arrange_sections_page_home/request";

export type HomePageSectionsArrangementListLoading = "list" | "details" | "create" | "update" | "delete";

export interface IInternalState {
  loading: HomePageSectionsArrangementListLoading[];

  list?: IBaseListingResponse<IHomePageSectionsArrangementList>;
  query: IHomePageSectionsArrangementQuery;
  details?: IHomePageSectionsArrangementList

}

export const internalState: IInternalState = {
  loading: [],
  query: DEFAULT_QUERY,
};

export interface IExternalState extends IInternalState {
  actions: {
    getData: () => void;

    updateHomePageSectionsArrangement: (id: number, request: IHomePageSectionsArrangement) => void;
    createHomePageSectionsArrangement: (request: IHomePageSectionsArrangement) => void;
    deleteHomePageSectionsArrangement: (id: number) => void;
    setQuery: (query: IHomePageSectionsArrangementQuery) => void;
    setSearch: (search?: string) => void;

  };
}

export const externalState: IExternalState = {
  ...internalState,
  actions: {
    getData: DEFAULT_FUNCTION,
    updateHomePageSectionsArrangement: DEFAULT_FUNCTION,
    createHomePageSectionsArrangement: DEFAULT_FUNCTION,
    deleteHomePageSectionsArrangement: DEFAULT_FUNCTION,
    setSearch: DEFAULT_FUNCTION,
    setQuery: DEFAULT_FUNCTION,
  },
};

const HomePageSectionsArrangementContext = createContext(externalState);

export default HomePageSectionsArrangementContext;
